'use client';
import { useVoicePageControl, voiceSelectOption } from '@/lib/voice/page-controls';
import { HStack } from '@chakra-ui/react';
import { FilterPill } from './FilterPill';

export interface SegmentedControlOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedControlProps<T extends string> {
  value: T;
  label?: string;
  options: Array<SegmentedControlOption<T>>;
  onValueChange: (value: T) => void;
}

export function SegmentedControl<T extends string>({
  value,
  label = 'View',
  options,
  onValueChange,
}: SegmentedControlProps<T>) {
  const voiceRef = useVoicePageControl({
    label,
    kind: 'select',
    value,
    options,
    apply(requested) {
      const next = voiceSelectOption(options, requested) as T;
      onValueChange(next);
      return next;
    },
  });
  return (
    <HStack ref={voiceRef} gap="1" layerStyle="surfaceMuted" p="1">
      {options.map(option => (
        <FilterPill
          key={option.value}
          selected={option.value === value}
          borderRadius="glassInput"
          borderColor="transparent"
          onClick={() => onValueChange(option.value)}
        >
          {option.label}
        </FilterPill>
      ))}
    </HStack>
  );
}
